import { useParams } from 'react-router-dom';
import data from '../siteData';
import VideoPlayer from '../components/VideoPlayer';

export default function Case() {
  const { slug } = useParams();
  const item = data.projects.find((p) => p.slug === slug);
  if (!item) return <div className="p-10 text-white">Not found.</div>;

  return (
    <div className="min-h-screen bg-black text-white">
      <section className="max-w-5xl mx-auto p-6 md:p-10">
        <h1 className="text-4xl font-extrabold">{item.title}</h1>
        <p className="opacity-70 mt-2">{item.client} • {item.role.join(' / ')}</p>
        <div className="mt-6 aspect-video rounded-2xl overflow-hidden bg-neutral-900">
          <VideoPlayer src={item.src} poster={item.poster} className="w-full h-full object-cover" />
        </div>
        <article className="prose prose-invert mt-8">
          <p>{item.description}</p>
        </article>
      </section>
    </div>
  );
}